import { render, staticRenderFns } from "./CustomReports.vue?vue&type=template&id=7ef74506&"
import script from "./CustomReports.vue?vue&type=script&lang=js&"
export * from "./CustomReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports